// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SkinFilledSvg from "@fishx/icons-svg/es/asn/SkinFilled";
import FishxIcon from '../components/FishxIcon';

var SkinFilled = function SkinFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SkinFilledSvg
  }));
};

SkinFilled.displayName = 'SkinFilled';
export default React.forwardRef(SkinFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SkinFilled.js
// module id = 4132
// module chunks = 0